import { render, staticRenderFns } from "./ChurchLocation.vue?vue&type=template&id=1d46164f&scoped=true&"
import script from "./ChurchLocation.vue?vue&type=script&lang=js&"
export * from "./ChurchLocation.vue?vue&type=script&lang=js&"
import style0 from "./ChurchLocation.vue?vue&type=style&index=0&id=1d46164f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d46164f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardSubtitle,VCol,VContainer,VImg,VRow})
